import { API_BASE_URL, deleteRequest, getRequest, patchRequest, postRequest, putRequest } from '../../../api';
import { getSessionItem } from '../../utils/tokenStorage';

const baseUrl = `${API_BASE_URL}/api/v1/task-settings`;
const token = () => getSessionItem('token');

export const taskSettingsApi = {
    getAllSettings: () => getRequest({ url: baseUrl, token: token() }),
    getSettingById: (id) => getRequest({ url: `${baseUrl}/${id}`, token: token() }),
    createSetting: (data) => postRequest({ url: baseUrl, data, token: token() }),
    updateSetting: (id, data) => putRequest({ url: `${baseUrl}/${id}`, data, token: token() }),
    deleteSetting: (id) => deleteRequest({ url: `${baseUrl}/${id}`, token: token() }),
    toggleSettingStatus: (id) => patchRequest({ url: `${baseUrl}/${id}/toggle-status`, token: token() })
};
